import request from "./baseEntryRequire";
import {cardInfoType} from "/#/api";
import {simCardInfo} from "/#/store";

/**
 * 查询卡基础信息
 * iccid 卡号
 */
export function getCardInfo(data: cardInfoType): Promise<simCardInfo> {
    return request({
        url: '/card/info/query',
        method: 'post',
        data
    })
}